import { getGlobalSpaceService } from './utils/getGlobalSpaceService';

export async function deleteGlobalSpace(spaceID: string): Promise<void> {
  await getGlobalSpaceService().remove(spaceID);
}
